import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../i18n';

function Stat({ target, label, suffix, sub, locale }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      let raf; const start = performance.now(); const dur = 1400;
      const tick = (t) => { const p = Math.min(1, (t - start) / dur); setN(Math.round(target * (1 - Math.pow(1 - p, 3)))); if (p < 1) raf = requestAnimationFrame(tick); };
      raf = requestAnimationFrame(tick); obs.disconnect();
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target]);
  return (
    <div ref={ref} style={{ textAlign: 'center' }}>
      <div className="font-sora metallic-gold" style={{ fontSize: 'clamp(34px, 5vw, 54px)', fontWeight: 800 }}>{n.toLocaleString(locale)}{suffix}</div>
      <div style={{ marginTop: 6, fontSize: 14, color: 'var(--color-neutral-400)' }}>{label}</div>
      {sub && <div style={{ marginTop: 2, fontSize: 12, color: 'var(--color-neutral-600)' }}>{sub}</div>}
    </div>
  );
}

export default function DataSources() {
  const { t, lang } = useI18n();
  const locale = { fr: 'fr-FR', en: 'en-US', es: 'es-ES' }[lang] || 'fr-FR';
  return (
    <section style={{ padding: '32px 24px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
        <p style={{ fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--hm-gold)', margin: 0 }}>{t.data.eyebrow}</p>
        <h2 className="font-sora" style={{ margin: '10px 0 0', fontSize: 'clamp(26px, 4vw, 42px)', fontWeight: 800, letterSpacing: '-0.02em' }}>{t.data.title}</h2>
        <p style={{ margin: '12px auto 0', maxWidth: '52ch', fontSize: 16, color: 'var(--color-neutral-400)', lineHeight: 1.6 }}>{t.data.subtitle}</p>
        <div style={{ marginTop: 40, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 30 }}>
          <Stat target={142} label={t.data.s1} suffix="+" locale={locale} />
          <Stat target={23} label={t.data.s2} suffix="" locale={locale} />
          <Stat target={18} label={t.data.s3} suffix="" sub={t.data.s3sub} locale={locale} />
          <Stat target={3} label={t.data.s4} suffix="" locale={locale} />
        </div>
      </div>
    </section>
  );
}
